import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setCompanies,
  setCompanyTypes,
  addCompany,
  removeCompany,
  setSelectedCompany,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,
  setSingleCompany
} from "./companySlice";
import companyAPI from "../../services/companyAPI";
import { use } from "react";
// Fetch all companies
export const fetchCompanies = createAsyncThunk(
  "company/fetchCompanies",
  async (_, { dispatch, getState }) => {
    dispatch(apiRequestStart());
    try {
      const response = await companyAPI.getAllCompanies();
      const companies = response.data.data.data;
      dispatch(setCompanies(companies));
      // Handle selected company initialization
      const state = getState();
      const storedCompanyId = localStorage.getItem("company_id");
      const currentSelectedCompany = state.company.selectedCompany;
      const user = state.auth.user;
      const isSUPERADMIN = user.role_id === 'SUPERADMIN';
      // If not SUPERADMIN, ensure user can only select their assigned company
      if (!isSUPERADMIN && user?.company_id) {
        const userCompany = companies.find(
          company => company.id.toString() === user.company_id.toString()
        );
        if (userCompany) {
          dispatch(setSelectedCompany(userCompany));
          // Update localStorage
          localStorage.setItem("company_id", userCompany.id.toString());
        }
      }
      // If SUPERADMIN or no company_id in user, handle normal selection logic
      else if (storedCompanyId && !currentSelectedCompany) {
        const selectedCompany = companies.find(
          company => company.id.toString() === storedCompanyId.toString()
        );
        if (selectedCompany) {
          dispatch(setSelectedCompany(selectedCompany));
        }
      }
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch companies.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);
// Select a company - with role check
export const selectCompany = createAsyncThunk(
  "company/selectCompany",
  async (companyId, { dispatch, getState }) => {
    try {
      const state = getState();
      const companies = state.company.companies;
      const user = state.auth.user;
      const isSUPERADMIN = user.role_id === 'SUPERADMIN';
      // Check if user is allowed to select this company
      if (!isSUPERADMIN && user?.company_id &&
        user.company_id.toString() !== companyId.toString()) {
          throw new Error("You don't have permission to select this company");
        }
        console.log("hereeeeeeeee")
      const selectedCompany = companies.find(
        company => company.id.toString() === companyId.toString()
      );
      if (selectedCompany) {
        dispatch(setSelectedCompany(selectedCompany));
        return selectedCompany;
      } else {
        throw new Error("Company not found");
      }
    } catch (error) {
      throw new Error(error.message || "Failed to select company");
    }
  }
);
// Fetch company types
export const fetchCompanyTypes = createAsyncThunk(
  "company/fetchCompanyTypes",
  async (_, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await companyAPI.getCompanyTypes();
      dispatch(setCompanyTypes(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch company types.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);
// Add a new company
export const createCompany = createAsyncThunk(
  "company/createCompany",
  async (companyData, { dispatch, getState }) => {
    dispatch(apiRequestStart());
    try {
      // Check if user has permission to create company
      const state = getState();
      const user = state.auth.user;
      if (user?.role_id !== 'SUPERADMIN') {
        throw new Error("You don't have permission to create companies");
      }
      const response = await companyAPI.createCompany(companyData);
      dispatch(addCompany(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to create company.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);
// Update a company
export const updateCompany = createAsyncThunk(
  "company/updateCompany",
  async ({ id, companyData }, { dispatch, getState }) => {
    dispatch(apiRequestStart());
    try {
      // Check if user has permission to update this company
      const state = getState();
      const user = state.auth.user;
      if (user.role_id !== 'SUPERADMIN' &&
          user?.company_id?.toString() !== id.toString()) {
        throw new Error("You don't have permission to update this company");
      }
      const response = await companyAPI.updateCompany(id, companyData);
      // Update the company in the Redux state
      dispatch(updateCompany(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to update company.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);
// Delete a company
export const deleteCompany = createAsyncThunk(
  "company/deleteCompany",
  async (companyId, { dispatch, getState }) => {
    dispatch(apiRequestStart());
    try {
      // Check if user has permission to delete company
      const state = getState();
      const user = state.auth.user;
      if (user.role_id !== 'SUPERADMIN') {
        throw new Error("You don't have permission to delete companies");
      }
      await companyAPI.deleteCompany(companyId);
      dispatch(removeCompany(companyId));
      dispatch(apiRequestSuccess());
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete company.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);
export const fetchSingleCompany = createAsyncThunk(
  "company/fetchSingleCompany",
  async (companyId, { dispatch, getState }) => {
    dispatch(apiRequestStart());
    try {
      // Check if user has permission to view this company
      const state = getState();
      const user = state.auth.user;
      if (user.role_id !== 'SUPERADMIN' &&
          user?.company_id?.toString() !== companyId.toString()) {
        throw new Error("You don't have permission to view this company");
      }
      const response = await companyAPI.singleCompany(companyId);
      console.log("Single company data received:", response.data.data);
      dispatch(setSingleCompany(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch company details.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);